import { render, staticRenderFns } from "./VarroaEdit.vue?vue&type=template&id=aeb94684&scoped=true&"
import script from "./VarroaEdit.vue?vue&type=script&lang=js&"
export * from "./VarroaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb94684",
  null
  
)

export default component.exports